import React, { useEffect, useState } from "react";
import { Table, TableColumn } from "../../../components/table";
import HeaderBar from "../../../components/header/headerBar";
import IconMdi from "@mdi/react";
import { mdiPencilCircle, mdiDelete, mdiPlus } from "@mdi/js";
import { SearchField } from "../../../components/textfield";
import Select from "../../../components/select/select";
import Import from "../../../components/button/Import";
import { useHistory } from "react-router-dom";
import { Modal, Button } from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";
import moment from "moment";
const Po = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<any>([]);
  const [state, setState] = useState<any>({
    data: [],
  });

  const columns = [
    {
      title: "",
    },
    {
      title: "เลชที่ใบขอซื้อ<br/>PR No.",
      align: "center",
    },
    {
      title: "เลชที่ใบขอซื้อ<br/>PO No.",
      align: "center",
    },
    {
      title: "วันที่ขอซื้อ<br/>Date Order",
      align: "center",
    },
    {
      title: "สถานะ<br/>Status",
      align: "center",
    },
    {
      title: "แก้ไข<br/>Edit",
      align: "center",
    },
    {
      title: "ลบ<br/>Delete",
      align: "center",
    },
  ];
  const option = [
    { value: "branch1", name: "All" },
    { value: "branch2", name: "All" },
    { value: "branch3", name: "All" },
    { value: "branch4", name: "All" },
  ];

  function onClose() {
    setIsOpen(false);
  }

  const getAPIs = () => {
    setState({ ...state, data: data });
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        axios.delete(`/stock-products/po/${id}`).then((res: any) => {
          getDataPr();
        });
      },
      width: "fit-content"
    });
  }

  useEffect(() => {
    getAPIs();
    getDataPr();
  }, []);

  const getDataPr = () => {
    axios.get(`/stock-products/pr`).then((res) => {
      setData(res?.data)
    });
  }
  return (
    <div>
      <HeaderBar title="PO Order" />

      <div style={{ padding: "10px 40px" }}>
        <SearchField placeholder="Search for  PR No." color="#fff" />
        <div style={{ marginTop: "20px" }}>
          <div className="email_type">
            <Select title="Search for  PR No." option={option} />
          </div>
        </div>
        <div style={{ marginTop: "100px" }}>
          <Table header={columns}>
            {
              data &&
              data?.data?.map((item: any, index: number) => (
                <tr key={index} style={{ cursor: "pointer" }}>
                  <TableColumn width="3%" align="center">
                    {index + 1}
                  </TableColumn>
                  <TableColumn width="20%" align="center">{item?.code}</TableColumn>
                  <TableColumn width="20%" align="center">{item?.poCode}</TableColumn>
                  <TableColumn width="20%" align="center">{moment(item?.dateOder).format('DD-MM-YYYY')}</TableColumn>
                  <TableColumn width="20%" align="center">
                    <Button type="primary" shape="round" danger style={{
                      borderColor: (item?.statusProcess === "Approved") ? "#4D7E7F" : (item?.statusProcess === "Pending") ? "#F3A086" : "#E76464",
                      background: (item?.statusProcess === "Approved") ? "#4D7E7F" : (item?.statusProcess === "Pending") ? "#F3A086" : "#E76464"
                    }}>
                      {item?.statusProcess || "Disapproved"}
                    </Button>
                  </TableColumn>
                  <TableColumn width="5%" align="center">
                    <div
                      onClick={() => {
                        history.push(
                          `/setting/inventory/poApprove/${item._id}`
                        );
                      }}
                    >
                      <IconMdi path={mdiPencilCircle} size="30" color="#5BAEA9" />
                    </div>
                  </TableColumn>
                  <TableColumn
                    width="5%"
                    align="center"
                    onClick={() => {
                      showDeleteConfirm(item._id, item.list)
                    }}
                  >
                    <div>
                      <IconMdi path={mdiDelete} size="25" color="#FF6760"></IconMdi>
                    </div>
                  </TableColumn>
                </tr>
              ))
            }
          </Table>
        </div>
      </div>
    </div>
  );
};
export default Po;
